import React from "react";
import { ScenarioComp } from "./ScenarioComp";
import { useTranslation } from "react-i18next";
const data = [
  {
    name: "موزیک",
    type: "music",
    icon: "muic",
  },
  {
    name: "شب",
    type: "night",
    icon: "slepp",
  },
  {
    name: "بیرون خانه",
    type: "outside",
    icon: "out",
  },
  {
    name: "در خانه",
    type: "inside",
    icon: "in",
  },
];

const ScenariosList = () => {
  const { t } = useTranslation();
  return (
    <div className="mt-5">
      <p className="fn text-right mb-4">{t("سناریوها")}</p>
      <div
        className="d-flex justify-content-between flex-wrap"
        style={{ overflow: "auto", maxHeight: "55vh" }}
      >
        {data.map((item) => (
          <ScenarioComp name={item.name} type={item.type} icon={item.icon} />
        ))}
      </div>
    </div>
  );
};

export { ScenariosList };
